import { Facebook, Instagram } from "lucide-react";

const socials = [
  {
    label: "Facebook",
    href: "https://www.facebook.com/profile.php?id=61561263476067",
    icon: Facebook,
    bg: "bg-[hsl(220,46%,48%)]",
  },
  {
    label: "Instagram",
    href: "https://www.instagram.com/rewe.kotlarski/",
    icon: Instagram,
    bg: "bg-[hsl(330,70%,50%)]",
  },
];

const SocialFloatingButtons = () => (
  <div className="fixed left-4 top-1/2 -translate-y-1/2 z-40 hidden md:flex flex-col gap-3">
    {socials.map((s) => (
      <a
        key={s.label}
        href={s.href}
        target="_blank"
        rel="noopener noreferrer"
        aria-label={`${s.label} Profil besuchen`}
        className={`${s.bg} text-primary-foreground w-11 h-11 rounded-md flex items-center justify-center shadow-lg hover:scale-110 transition-transform duration-200 focus:outline-none focus:ring-2 focus:ring-primary focus:ring-offset-2 focus:ring-offset-background`}
      >
        <s.icon size={20} aria-hidden="true" />
      </a>
    ))}
  </div>
);

export default SocialFloatingButtons;